module.exports = __webpack_public_path__ + "static/media/44 - Grace Jones - My Jamaican Guy.bb0853d0.mp3";